module.exports = __webpack_public_path__ + "static/media/oculus.18fb8e35.png";